// Editorial curation configuration for homepage
export const editorialConfig = {
  // Hero story - manually selected breaking news or major story
  heroStory: {
    postId: null, // Set to specific WordPress post ID for manual curation
    fallbackCategory: 'Film', // Fallback to latest from this category
    priority: 1
  },
  
  // Featured stories with category balance
  featuredStories: {
    totalCount: 5,
    categoryBalance: {
      'Film': 2,
      'TV': 1,
      'Awards': 1,
      'Festivals': 1
    },
    fallbackToLatest: true // If not enough in categories, fill with latest
  },
  
  // Latest articles section
  latestArticles: {
    count: 8,
    excludeFeatured: true, // Don't repeat featured articles
    mixCategories: true
  },
  
  // WordPress category mapping
  categoryMapping: {
    524: 'Film',
    462: 'TV', 
    8215: 'Festivals',
    1: 'Awards',
    // Add more as needed
  }
};

// Helper function to get balanced articles by category
export const getBalancedArticles = (articles, balance) => {
  const result = [];
  const categorizedArticles = {};
  
  // Group articles by category
  articles.forEach(article => {
    const category = article.category || 'News';
    if (!categorizedArticles[category]) {
      categorizedArticles[category] = [];
    }
    categorizedArticles[category].push(article);
  });
  
  // Select articles based on balance requirements
  Object.entries(balance).forEach(([category, count]) => {
    const categoryArticles = categorizedArticles[category] || [];
    const selected = categoryArticles.slice(0, count);
    result.push(...selected);
  });
  
  // Fill remaining slots if needed
  const remaining = Math.max(0, 5 - result.length);
  if (remaining > 0) {
    const usedIds = new Set(result.map(a => a.id));
    const remainingArticles = articles
      .filter(a => !usedIds.has(a.id))
      .slice(0, remaining);
    result.push(...remainingArticles);
  }
  
  return result.slice(0, 5);
};